import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { IMeetingArchiveFormProps } from './types';
import { FormTextInput } from '../../inputs/TextInput';
import { updateSession } from '../../../../../app/page/page-storage/sessions/sessions.actions';
import { closeDialog } from '../../../../../app/dialog/dialog.actions';

export const MeetingArchiveLinkForm: FunctionComponent<IMeetingArchiveFormProps> = ({ archive }) => {
  const dispatch = useDispatch();

  const formProps = useForm();

  const onSubmit = (data: { link: string | null }) => {
    if (data.link?.trim().length === 0) {
      data.link = null;
    }

    dispatch(updateSession(archive.id, { link: data.link }));
    dispatch(closeDialog('meetingArchiveLinkFormDialog'));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="meetingArchiveLinkFormDialog-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as { link: string | null }))}
        method="post"
      >
        <div className="field-container">
          <FormTextInput
            id="link"
            name="link"
            type="text"
            defaultValue={archive.link}
            label="Enter a link"
            placeholder="www.example.com"
          />
        </div>
      </form>
    </FormProvider>
  );
};
